module.exports = __webpack_public_path__ + "img/Set V1.8e32240c.jpg";